import React, {Component} from 'react';
import ListMenu from './ListMenu';

export default class SideNav extends Component {

    constructor(props) {
        super(props);

        // Creating a variable inside the constructor
        this.sidebarNavItems = [
            {
                name: 'Introduction to Syncloop',
                folder: 'introduction-to-syncloop',
                url: '/docs/introduction-to-syncloop',
                submenu: [
                    {
                        name: 'Getting Started',
                        folder: '/introduction-to-syncloop/introduction-to-syncloop',
                        url: '/docs/introduction-to-syncloop/introduction-to-syncloop',

                    }
                ]

            },
            {
                name: 'Quick Start Syncloop',
                folder: 'quick-start-syncloop',
                url: '/docs/quick-start-syncloop',
                submenu: [
                    {
                        name: 'Hello World API',
                        folder: '/quick-start-syncloop/hello-world-api',
                        url: '/docs/quick-start-syncloop/hello-world-api'
                    },
                    {
                        name: 'Conditional Logic',
                        folder: '/quick-start-syncloop/conditional-logic',
                        url: '/docs/quick-start-syncloop/conditional-logic'
                    },
                    {
                        name: 'Looping Logic',
                        folder: '/quick-start-syncloop/looping-logic',
                        url: '/docs/quick-start-syncloop/looping-logic'
                    },
                    {
                        name: 'Weather API',
                        folder: '/quick-start-syncloop/weather-api',
                        url: '/docs/quick-start-syncloop/weather-api'
                    },
                    {
                        name: 'Crypto Currency Conversion',
                        folder: '/quick-start-syncloop/crypto-currency-conversion',
                        url: '/docs/quick-start-syncloop/crypto-currency-conversion'
                    },
                    {
                        name: 'Return Custom HTTP Elements',
                        folder: '/quick-start-syncloop/return-custom-http-elements',
                        url: '/docs/quick-start-syncloop/return-custom-http-elements'
                    },
                    {
                        name: 'Exception Handling',
                        folder: '/quick-start-syncloop/exception-handling',
                        url: '/docs/quick-start-syncloop/exception-handling'
                    }

                ]

            },
            {
                name: 'API Developer Guide',
                folder: 'api-developer-guide',
                url: '/docs/api-developer-guide',
                submenu: [
                    {
                        name: 'middleware',
                        folder: '/api-developer-guide/middleware',
                        url: '/docs/api-developer-guide/middleware',
                        submenu: [
                            {
                                name: 'pub',
                                folder: '/api-developer-guide/middleware/pub',
                                url: '/docs/api-developer-guide/middleware/pub',
                                submenu: [
                                    {
                                        name: 'client',
                                        folder: '/api-developer-guide/middleware/pub/client',
                                        url: '/docs/api-developer-guide/middleware/pub/client',
                                        submenu: [
                                            {
                                                name: 'database',
                                                folder: '/api-developer-guide/middleware/pub/client/database',
                                                url: '/docs/api-developer-guide/middleware/pub/client/database',
                                                submenu: [
                                                    {
                                                        name: 'commitTransaction',
                                                        folder: 'commitTransaction',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/database/commitTransaction',
                                                    },
                                                    {
                                                        name: 'createSavepoint',
                                                        folder: 'createSavepoint',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/database/createSavepoint',
                                                    },
                                                    {
                                                        name: 'rollbackTransaction',
                                                        folder: 'rollbackTransaction',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/database/rollbackTransaction',
                                                    },
                                                    {
                                                        name: 'setTransactionIsolationLevel',
                                                        folder: 'setTransactionIsolationLevel',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/database/setTransactionIsolationLevel',
                                                    },
                                                    {
                                                        name: 'startTransaction',
                                                        folder: 'startTransaction',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/database/startTransaction',
                                                    }



                                                ]
                                            },
                                            {
                                                name: 'http',
                                                folder: '/api-developer-guide/middleware/pub/client/http',
                                                url: '/docs/api-developer-guide/middleware/pub/client/http',
                                                submenu: [
                                                    {
                                                        name: 'request',
                                                        folder: 'request',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/http/request',
                                                    },
                                                    {
                                                        name: 'requestAPI',
                                                        folder: 'requestAPI',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/http/requestAPI',
                                                    },
                                                    {
                                                        name: 'urlMeta',
                                                        folder: 'urlMeta',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/http/urlMeta',
                                                    }

                                                ]
                                            },
                                            {
                                                name: 'sftp',
                                                folder: '/api-developer-guide/middleware/pub/client/sftp',
                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp',
                                                submenu: [
                                                    {
                                                        name: 'commands',
                                                        folder: '/api-developer-guide/middleware/pub/client/sftp/commands',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands',
                                                        submenu: [
                                                            {
                                                                name: 'close',
                                                                folder: 'close',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/close'
                                                            },
                                                            {
                                                                name: 'createFile',
                                                                folder: 'createFile',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/createFile'
                                                            },
                                                            {
                                                                name: 'getFileInputStream',
                                                                folder: 'getFileInputStream',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/getFileInputStream'
                                                            },
                                                            {
                                                                name: 'getFileOutputStream',
                                                                folder: 'getFileOutputStream',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/getFileOutputStream'
                                                            },
                                                            {
                                                                name: 'list',
                                                                folder: 'list',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/list'
                                                            },
                                                            {
                                                                name: 'open',
                                                                folder: '/open',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/open'
                                                            },
                                                            {
                                                                name: 'readFile',
                                                                folder: 'readFile',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/readFile'
                                                            },
                                                            {
                                                                name: 'rename',
                                                                folder: 'rename',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/rename'
                                                            },
                                                            {
                                                                name: 'writeFile',
                                                                folder: 'writeFile',
                                                                url: '/docs/api-developer-guide/middleware/pub/client/sftp/commands/writeFile'
                                                            }
                                                        ]

                                                    }
                                                ]

                                            },
                                            {
                                                name: 'utils',
                                                folder: '/api-developer-guide/middleware/pub/client/utils',
                                                url: '/docs/api-developer-guide/middleware/pub/client/utils',
                                                submenu:[
                                                    {
                                                        name: 'getCurrentBasePath',
                                                        folder: 'getCurrentBasePath',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/utils/getCurrentBasePath'

                                                    },
                                                    {
                                                        name: 'getCurrentURI',
                                                        folder: 'getCurrentURI',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/utils/getCurrentURI'

                                                    },
                                                    {
                                                        name: 'guessContentTypeFromName',
                                                        folder: 'guessContentTypeFromName',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/utils/guessContentTypeFromName'

                                                    },
                                                    {
                                                        name: 'responseHeader',
                                                        folder: 'responseHeader',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/utils/responseHeader'

                                                    },
                                                    {
                                                        name: 'urlEncoder',
                                                        folder: 'urlEncoder',
                                                        url: '/docs/api-developer-guide/middleware/pub/client/utils/urlEncoder'

                                                    }

                                                ]
                                            }

                                        ]

                                    },
                                    {
                                        name: 'collection',
                                        folder: '/api-developer-guide/middleware/pub/collection',
                                        url: '/docs/api-developer-guide/middleware/pub/collection',
                                        submenu: [
                                            {
                                                name: 'list',
                                                folder: '/api-developer-guide/middleware/pub/collection/list',
                                                url: '/docs/api-developer-guide/middleware/pub/collection/list',
                                                submenu:[
                                                    {
                                                        name: 'add',
                                                        folder: 'add',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/list/add'
                                                    },
                                                    {
                                                        name: 'ArrayList',
                                                        folder: 'ArrayList',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/list/ArrayList'
                                                    },
                                                    {
                                                        name: 'createArrayList',
                                                        folder: 'createArrayList',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/list/createArrayList'
                                                    },
                                                    {
                                                        name: 'delete',
                                                        folder: 'delete',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/list/delete'
                                                    },
                                                    {
                                                        name: 'size',
                                                        folder: 'size',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/list/size'
                                                    }

                                                ]

                                            },
                                            {
                                                name: 'map',
                                                folder: '/api-developer-guide/middleware/pub/collection/map',
                                                url: '/docs/api-developer-guide/middleware/pub/collection/map',
                                                submenu:[
                                                    {
                                                        name: 'createHashTable',
                                                        folder: 'createHashTable',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/map/createHashTable'
                                                    },
                                                    {
                                                        name: 'Delete',
                                                        folder: 'Delete',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/map/delete'
                                                    },
                                                    {
                                                        name: 'Get',
                                                        folder: 'Get',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/map/get'
                                                    },
                                                    {
                                                        name: 'HashMap',
                                                        folder: 'HashMap',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/map/hashMap'
                                                    },
                                                    {
                                                        name: 'Put',
                                                        folder: 'Put',
                                                        url: '/docs/api-developer-guide/middleware/pub/collection/map/put'
                                                    }

                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: 'date',
                                        folder: '/api-developer-guide/middleware/pub/date',
                                        url: '/docs/api-developer-guide/middleware/pub/date',
                                        submenu:[
                                            {
                                                name: 'compareDates',
                                                folder: 'compareDates',
                                                url: '/docs/api-developer-guide/middleware/pub/date/compareDates'

                                            },
                                            {
                                                name: 'convertTimeZone',
                                                folder: 'convertTimeZone',
                                                url: '/docs/api-developer-guide/middleware/pub/date/convertTimeZone'

                                            },
                                            {
                                                name: 'convertToUTC',
                                                folder: 'convertToUTC',
                                                url: '/docs/api-developer-guide/middleware/pub/date/convertToUTC'

                                            },
                                            {
                                                name: 'currentNanoTime',
                                                folder: 'currentNanoTime',
                                                url: '/docs/api-developer-guide/middleware/pub/date/currentNanoTime'

                                            },
                                            {
                                                name: 'dateDifference',
                                                folder: 'dateDifference',
                                                url: '/docs/api-developer-guide/middleware/pub/date/dateDifference'

                                            },
                                            {
                                                name: 'dateSubtract',
                                                folder: 'dateSubtract',
                                                url: '/docs/api-developer-guide/middleware/pub/date/dateSubtract'

                                            },
                                            {
                                                name: 'dateToString',
                                                folder: 'dateToString',
                                                url: '/docs/api-developer-guide/middleware/pub/date/dateToString'

                                            },
                                            {
                                                name: 'dateToTimestamp',
                                                folder: 'dateToTimestamp',
                                                url: '/docs/api-developer-guide/middleware/pub/date/dateToTimestamp'

                                            },
                                            {
                                                name: 'elapsedNanoTime',
                                                folder: 'elapsedNanoTime',
                                                url: '/docs/api-developer-guide/middleware/pub/date/elapsedNanoTime'

                                            },
                                            {
                                                name: 'getCurrentDateTime',
                                                folder: 'getCurrentDateTime',
                                                url: '/docs/api-developer-guide/middleware/pub/date/getCurrentDateTime'

                                            },
                                            {
                                                name: 'getPeriod',
                                                folder: 'getPeriod',
                                                url: '/docs/api-developer-guide/middleware/pub/date/getPeriod'

                                            },
                                            {
                                                name: 'getWorkingDays',
                                                folder: 'getWorkingDays',
                                                url: '/docs/api-developer-guide/middleware/pub/date/getWorkingDays'

                                            },
                                            {
                                                name: 'isLastDayOfMonth',
                                                folder: 'isLastDayOfMonth',
                                                url: '/docs/api-developer-guide/middleware/pub/date/isLastDayOfMonth'

                                            },
                                            {
                                                name: 'isLastDyOfMonth',
                                                folder: 'isLastDyOfMonth',
                                                url: '/docs/api-developer-guide/middleware/pub/date/isLastDyOfMonth'

                                            },
                                            {
                                                name: 'stringToDate',
                                                folder: 'stringToDate',
                                                url: '/docs/api-developer-guide/middleware/pub/date/stringToDate'

                                            },
                                            {
                                                name: 'timeToText',
                                                folder: 'timeToText',
                                                url: '/docs/api-developer-guide/middleware/pub/date/timeToText'

                                            }
                                        ]

                                    },
                                    {
                                        name: 'docList',
                                        folder: '/api-developer-guide/middleware/pub/docList',
                                        url: '/docs/api-developer-guide/middleware/pub/docList',
                                        submenu:[
                                            {
                                                name: 'addDoc',
                                                folder: 'addDoc',
                                                url: '/docs/api-developer-guide/middleware/pub/docList/addDoc'
                                            },
                                            {
                                                name: 'deleteDocFromList',
                                                folder: 'deleteDocFromList',
                                                url: '/docs/api-developer-guide/middleware/pub/docList/deleteDocFromList'
                                            }
                                        ]

                                    },
                                    {
                                        name: 'file',
                                        folder: '/api-developer-guide/middleware/pub/file',
                                        url: '/docs/api-developer-guide/middleware/pub/file',
                                        submenu: [
                                            {
                                                name: 'bytesToFile',
                                                folder: 'bytesToFile',
                                                url: '/docs/api-developer-guide/middleware/pub/file/bytesToFile'

                                            },
                                            {
                                                name: 'csvReader',
                                                folder: 'csvReader',
                                                url: '/docs/api-developer-guide/middleware/pub/file/csvReader'

                                            },
                                            {
                                                name: 'fileToBytes',
                                                folder: 'fileToBytes',
                                                url: '/docs/api-developer-guide/middleware/pub/file/fileToBytes'

                                            },
                                            {
                                                name: 'fileToFileObject',
                                                folder: '/api-developer-guide/middleware/pub/fileToFileObject',
                                                url: '/docs/api-developer-guide/middleware/pub/file/fileToFileObject'

                                            },
                                            {
                                                name: 'flat',
                                                folder: '/api-developer-guide/middleware/pub/file/flat',
                                                url: '/docs/api-developer-guide/middleware/pub/file/flat',
                                                submenu:[
                                                    {
                                                        name: 'csvReader',
                                                        folder: 'csvReader',
                                                        url: '/docs/api-developer-guide/middleware/pub/file/flat/csvReader',
                                                    },
                                                    {
                                                        name: 'toFlatFile',
                                                        folder: 'toFlatFile',
                                                        url: '/docs/api-developer-guide/middleware/pub/file/flat/toFlatFile',
                                                    },

                                                ]

                                            },
                                            {
                                                name: 'flushAndCloseBW',
                                                folder: 'lushAndCloseBW',
                                                url: '/docs/api-developer-guide/middleware/pub/file/flushAndCloseBW'

                                            },
                                            {
                                                name: 'getBufferedReader',
                                                folder: 'getBufferedReader',
                                                url: '/docs/api-developer-guide/middleware/pub/file/getBufferedReader'

                                            },
                                            {
                                                name: 'getBufferedReaderFromBytes',
                                                folder: 'getBufferedReaderFromBytes',
                                                url: '/docs/api-developer-guide/middleware/pub/file/getBufferedReaderFromBytes'

                                            },
                                            {
                                                name: 'getBufferedReaderFromInputStream',
                                                folder: 'getBufferedReaderFromInputStream',
                                                url: '/docs/api-developer-guide/middleware/pub/file/getBufferedReaderFromInputStream'

                                            },
                                            {
                                                name: 'getBufferedWriter',
                                                folder: 'getBufferedWriter',
                                                url: '/docs/api-developer-guide/middleware/pub/file/getBufferedWriter'

                                            },
                                            {
                                                name: 'listFiles',
                                                folder: 'listFiles',
                                                url: '/docs/api-developer-guide/middleware/pub/file/listFiles'

                                            },
                                            {
                                                name: 'readLines',
                                                folder: 'readLines',
                                                url: '/docs/api-developer-guide/middleware/pub/file/readLines'

                                            },
                                            {
                                                name: 'serverPropertiesReader',
                                                folder: 'serverPropertiesReader',
                                                url: '/docs/api-developer-guide/middleware/pub/file/serverPropertiesReader'

                                            },
                                            {
                                                name: 'stringToFile',
                                                folder: 'stringToFile',
                                                url: '/docs/api-developer-guide/middleware/pub/file/stringToFile'

                                            },
                                            {
                                                name: 'verifyPath',
                                                folder: 'verifyPath',
                                                url: '/docs/api-developer-guide/middleware/pub/file/verifyPath'

                                            },
                                            {
                                                name: 'writeLines',
                                                folder: 'writeLines',
                                                url: '/docs/api-developer-guide/middleware/pub/file/writeLines'

                                            }


                                        ]

                                    },
                                    {
                                        name: 'graphQL',
                                        folder: '/api-developer-guide/middleware/pub/graphQL',
                                        url: '/docs/api-developer-guide/middleware/pub/graphQL',
                                        submenu: [
                                            {
                                                name: 'reset',
                                                folder: '/api-developer-guide/middleware/pub/graphQL/reset',
                                                url: '/docs/api-developer-guide/middleware/pub/graphQL/reset',
                                                submenu: [
                                                    {
                                                        name: 'flow',
                                                        folder: '/api-developer-guide/middleware/pub/graphQL/reset/flow',
                                                        url: '/docs/api-developer-guide/middleware/pub/graphQL/reset/flow',
                                                        submenu:[
                                                            {
                                                                name: 'applyGraphQL',
                                                                folder: 'applyGraphQL',
                                                                url: '/docs/api-developer-guide/middleware/pub/graphQL/reset/flow/applyGraphQL',
                                                            }
                                                        ]

                                                    },
                                                    {
                                                        name: 'java',
                                                        folder: '/api-developer-guide/middleware/pub/graphQL/reset/java',
                                                        url: '/docs/api-developer-guide/middleware/pub/graphQL/reset/java',
                                                        submenu:[
                                                            {
                                                                name: 'applyGraphQLSchema',
                                                                folder: 'applyGraphQLSchema',
                                                                url: '/docs/api-developer-guide/middleware/pub/graphQL/reset/java/applyGraphQLSchema'

                                                            },
                                                            {
                                                                name: 'getEntireSchema',
                                                                folder: 'getEntireSchema',
                                                                url: '/docs/api-developer-guide/middleware/pub/graphQL/reset/java/getEntireSchema'

                                                            },
                                                            {
                                                                name: 'getGraphQLSchema',
                                                                folder: 'getGraphQLSchema',
                                                                url: '/docs/api-developer-guide/middleware/pub/graphQL/reset/java/getGraphQLSchema'

                                                            },
                                                            {
                                                                name: 'introspectionQuery',
                                                                folder: 'introspectionQuery',
                                                                url: '/docs/api-developer-guide/middleware/pub/graphQL/reset/java/introspectionQuery'

                                                            }
                                                        ]
                                                    }
                                                ]

                                            }

                                        ]

                                    },
                                    {
                                        name: 'io',
                                        folder: '/api-developer-guide/middleware/pub/io',
                                        url: '/docs/api-developer-guide/middleware/pub/io',
                                        submenu:[
                                            {
                                                name: 'bytesToFile',
                                                folder: 'bytesToFile',
                                                url: '/docs/api-developer-guide/middleware/pub/io/bytesToFile'

                                            },
                                            {
                                                name: 'bytesToStream',
                                                folder: 'bytesToStream',
                                                url: '/docs/api-developer-guide/middleware/pub/io/bytesToStream'

                                            },
                                            {
                                                name: 'close',
                                                folder: 'close',
                                                url: '/docs/api-developer-guide/middleware/pub/io/close'

                                            },
                                            {
                                                name: 'createAsEmptyByteArray',
                                                folder: 'createAsEmptyByteArray',
                                                url: '/docs/api-developer-guide/middleware/pub/io/createAsEmptyByteArray'

                                            },
                                            {
                                                name: 'mark',
                                                folder: 'mark',
                                                url: '/docs/api-developer-guide/middleware/pub/io/mark'

                                            },
                                            {
                                                name: 'markSupported',
                                                folder: 'markSupported',
                                                url: '/docs/api-developer-guide/middleware/pub/io/markSupported'

                                            },
                                            {
                                                name: 'read',
                                                folder: 'read',
                                                url: '/docs/api-developer-guide/middleware/pub/io/read'

                                            },
                                            {
                                                name: 'readAsString',
                                                folder: 'readAsString',
                                                url: '/docs/api-developer-guide/middleware/pub/io/readAsString'

                                            },
                                            {
                                                name: 'readerToString',
                                                folder: 'readerToString',
                                                url: '/docs/api-developer-guide/middleware/pub/io/readerToString'

                                            },
                                            {
                                                name: 'replace',
                                                folder: 'replace',
                                                url: '/docs/api-developer-guide/middleware/pub/io/replace'

                                            },
                                            {
                                                name: 'reset',
                                                folder: 'reset',
                                                url: '/docs/api-developer-guide/middleware/pub/io/reset'

                                            },
                                            {
                                                name: 'skip',
                                                folder: 'skip',
                                                url: '/docs/api-developer-guide/middleware/pub/io/skip'

                                            },
                                            {
                                                name: 'streamToBytes',
                                                folder: 'streamToBytes',
                                                url: '/docs/api-developer-guide/middleware/pub/io/streamToBytes'

                                            },
                                            {
                                                name: 'streamToFile',
                                                folder: 'streamToFile',
                                                url: '/docs/api-developer-guide/middleware/pub/io/streamToFile'

                                            },
                                            {
                                                name: 'streamToReader',
                                                folder: 'streamToReader',
                                                url: '/docs/api-developer-guide/middleware/pub/io/streamToReader'

                                            },
                                            {
                                                name: 'streamToString',
                                                folder: 'streamToString',
                                                url: '/docs/api-developer-guide/middleware/pub/io/streamToString'

                                            },
                                            {
                                                name: 'stringToInputStream',
                                                folder: 'stringToInputStream',
                                                url: '/docs/api-developer-guide/middleware/pub/io/stringToInputStream'

                                            },
                                            {
                                                name: 'stringToReader',
                                                folder: 'stringToReader',
                                                url: '/docs/api-developer-guide/middleware/pub/io/stringToReader'

                                            }
                                        ]

                                    },
                                    {
                                        name: 'json',
                                        folder: '/api-developer-guide/middleware/pub/json',
                                        url: '/docs/api-developer-guide/middleware/pub/json',
                                        submenu:[
                                            {
                                                name: 'fromJson',
                                                folder: 'fromJson',
                                                url: '/docs/api-developer-guide/middleware/pub/json/fromJson'
                                            },
                                            {
                                                name: 'fromJsonList',
                                                folder: 'fromJsonList',
                                                url: '/docs/api-developer-guide/middleware/pub/json/fromJsonList'
                                            },
                                            {
                                                name: 'toJson',
                                                folder: 'toJson',
                                                url: '/docs/api-developer-guide/middleware/pub/json/toJson'
                                            },
                                            {
                                                name: 'toJsonSchema',
                                                folder: 'toJsonSchema',
                                                url: '/docs/api-developer-guide/middleware/pub/json/toJsonSchema'
                                            },
                                            {
                                                name: 'toString',
                                                folder: 'toString',
                                                url: '/docs/api-developer-guide/middleware/pub/json/toString'
                                            }
                                        ]

                                    },
                                    {
                                        name: 'jwt',
                                        folder: '/api-developer-guide/middleware/pub/jwt',
                                        url: '/docs/api-developer-guide/middleware/pub/jwt',
                                        submenu:[
                                            {
                                                name: 'generateIdentifierToken',
                                                folder: 'generateIdentifierToken',
                                                url: '/docs/api-developer-guide/middleware/pub/jwt/generateIdentifierToken'
                                            },
                                            {
                                                name: 'generateIdentifier',
                                                folder: 'generateIdentifier',
                                                url: '/docs/api-developer-guide/middleware/pub/jwt/generateIdentifier'
                                            }

                                        ]

                                    },
                                    {
                                        name: 'math',
                                        folder: '/api-developer-guide/middleware/pub/math',
                                        url: '/docs/api-developer-guide/middleware/pub/math',
                                        submenu:[
                                            {
                                                name: 'absoluteValue',
                                                folder: 'absoluteValue',
                                                url: '/docs/api-developer-guide/middleware/pub/math/absoluteValue'

                                            },
                                            {
                                                name: 'addFloatList',
                                                folder: 'addFloatList',
                                                url: '/docs/api-developer-guide/middleware/pub/math/addFloatList'

                                            },
                                            {
                                                name: 'addFloats',
                                                folder: 'addFloats',
                                                url: '/docs/api-developer-guide/middleware/pub/math/addFloats'

                                            },
                                            {
                                                name: 'addIntList',
                                                folder: 'addIntList',
                                                url: '/docs/api-developer-guide/middleware/pub/math/addIntList'

                                            },
                                            {
                                                name: 'addInts',
                                                folder: 'addInts',
                                                url: '/docs/api-developer-guide/middleware/pub/math/addInts'

                                            },
                                            {
                                                name: 'addObjects',
                                                folder: 'addObjects',
                                                url: '/docs/api-developer-guide/middleware/pub/math/addObjects'

                                            },
                                            {
                                                name: 'divideInts',
                                                folder: 'divideInts',
                                                url: '/docs/api-developer-guide/middleware/pub/math/divideInts'

                                            },
                                            {
                                                name: 'divideObjects',
                                                folder: 'divideObjects',
                                                url: '/docs/api-developer-guide/middleware/pub/math/divideObjects'

                                            },
                                            {
                                                name: 'max',
                                                folder: 'max',
                                                url: '/docs/api-developer-guide/middleware/pub/math/max'

                                            },
                                            {
                                                name: 'min',
                                                folder: 'min',
                                                url: '/docs/api-developer-guide/middleware/pub/math/min'

                                            },
                                            {
                                                name: 'multiplyFloats',
                                                folder: 'multiplyFloats',
                                                url: '/docs/api-developer-guide/middleware/pub/math/multiplyFloats'

                                            },
                                            {
                                                name: 'multiplyIntList',
                                                folder: 'multiplyIntList',
                                                url: '/docs/api-developer-guide/middleware/pub/math/multiplyIntList'

                                            },
                                            {
                                                name: 'multiplyInts',
                                                folder: 'multiplyInts',
                                                url: '/docs/api-developer-guide/middleware/pub/math/multiplyInts'

                                            },
                                            {
                                                name: 'multiplyList',
                                                folder: 'multiplyList',
                                                url: '/docs/api-developer-guide/middleware/pub/math/multiplyList'

                                            },
                                            {
                                                name: 'multiplyObjects',
                                                folder: 'multiplyObjects',
                                                url: '/docs/api-developer-guide/middleware/pub/math/multiplyObjects'

                                            },
                                            {
                                                name: 'randomDouble',
                                                folder: 'randomDouble',
                                                url: '/docs/api-developer-guide/middleware/pub/math/randomDouble'

                                            },
                                            {
                                                name: 'randomString',
                                                folder: 'randomString',
                                                url: '/docs/api-developer-guide/middleware/pub/math/randomString'

                                            },
                                            {
                                                name: 'roundNumber',
                                                folder: 'roundNumber',
                                                url: '/docs/api-developer-guide/middleware/pub/math/roundNumber'

                                            },
                                            {
                                                name: 'stringToNumber',
                                                folder: 'stringToNumber',
                                                url: '/docs/api-developer-guide/middleware/pub/math/stringToNumber'

                                            },
                                            {
                                                name: 'subtractFloats',
                                                folder: 'subtractFloats',
                                                url: '/docs/api-developer-guide/middleware/pub/math/subtractFloats'

                                            },
                                            {
                                                name: 'subtractInts',
                                                folder: 'subtractInts',
                                                url: '/docs/api-developer-guide/middleware/pub/math/subtractInts'

                                            },
                                            {
                                                name: 'subtractObjects',
                                                folder: 'subtractObjects',
                                                url: '/docs/api-developer-guide/middleware/pub/math/subtractObjects'

                                            }

                                        ]

                                    },
                                    {
                                        name: 'platform',
                                        folder: '/api-developer-guide/middleware/pub/platform',
                                        url: '/docs/api-developer-guide/middleware/pub/platform',
                                        submenu:[
                                            {
                                                name: 'checkPluginStatus',
                                                folder: 'checkPluginStatus',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/checkPluginStatus'

                                            },
                                            {
                                                name: 'checkPluginStatusAPI',
                                                folder: 'checkPluginStatusAPI',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/checkPluginStatusAPI'

                                            },
                                            {
                                                name: 'deleteAPlugin',
                                                folder: 'deleteAPlugin',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/deleteAPlugin'

                                            },
                                            {
                                                name: 'deletePlugin',
                                                folder: 'deletePlugin',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/deletePlugin'

                                            },
                                            {
                                                name: 'getMarketPlace',
                                                folder: 'getMarketPlace',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/getMarketPlace'

                                            },
                                            {
                                                name: 'installAPlugin',
                                                folder: 'installAPlugin',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/installAPlugin'

                                            },
                                            {
                                                name: 'installPlugin',
                                                folder: 'installPlugin',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/installPlugin'

                                            },
                                            {
                                                name: 'MarketPlace',
                                                folder: 'MarketPlace',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/MarketPlace'

                                            },
                                            {
                                                name: 'uninstallPlugin',
                                                folder: 'uninstallPlugin',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/uninstallPlugin'

                                            },
                                            {
                                                name: 'updateTenantBuilt',
                                                folder: 'updateTenantBuilt',
                                                url: '/docs/api-developer-guide/middleware/pub/platform/updateTenantBuilt'

                                            },

                                        ]

                                    },
                                    {
                                        name: 'security',
                                        folder: '/api-developer-guide/middleware/pub/security',
                                        url: '/docs/api-developer-guide/middleware/pub/security',
                                        submenu: [
                                            {
                                                name: 'basicLoginHandler',
                                                folder: 'basicLoginHandler',
                                                url: '/docs/api-developer-guide/middleware/pub/security/basicLoginHandler'

                                            },
                                            {
                                                name: 'initOIDCProfiles',
                                                folder: 'initOIDCProfiles',
                                                url: '/docs/api-developer-guide/middleware/pub/security/initOIDCProfiles'

                                            },
                                            {
                                                name: 'flow',
                                                folder: '/api-developer-guide/middleware/pub/security/flow',
                                                url: '/docs/api-developer-guide/middleware/pub/security/flow',
                                                submenu:[
                                                    {
                                                        name: 'addGroups',
                                                        folder: 'addGroups',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/flow/addGroups'

                                                    },
                                                    {
                                                        name: 'addUserFlow',
                                                        folder: 'addUserFlow',
                                                        url: 'addUserFlow'

                                                    },
                                                    {
                                                        name: 'changePasswordFlow',
                                                        folder: 'changePasswordFlow',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/flow/changePasswordFlow'

                                                    },
                                                    {
                                                        name: 'deleteGroup',
                                                        folder: 'deleteGroup',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/flow/deleteGroup'

                                                    },
                                                    {
                                                        name: 'deleteUser',
                                                        folder: 'deleteUser',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/flow/deleteUser'

                                                    },
                                                    {
                                                        name: 'getGroups',
                                                        folder: 'getGroups',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/flow/getGroups'

                                                    },
                                                    {
                                                        name: 'getUsers',
                                                        folder: 'getUsers',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/flow/getUsers'

                                                    },
                                                    {
                                                        name: 'updateUserFlow',
                                                        folder: 'updateUserFlow',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/flow/updateUserFlow'

                                                    }

                                                ]

                                            },
                                            {
                                                name: 'java',
                                                folder: '/api-developer-guide/middleware/pub/security/java',
                                                url: '/docs/api-developer-guide/middleware/pub/security/java',
                                                submenu:[
                                                    {
                                                        name: 'addGroup',
                                                        folder: 'addGroup',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/addGroup'

                                                    },
                                                    {
                                                        name: 'addUser',
                                                        folder: 'addUser',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/addUser'

                                                    },
                                                    {
                                                        name: 'changePassword',
                                                        folder: 'changePassword',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/changePassword'

                                                    },
                                                    {
                                                        name: 'createOIDCProfile',
                                                        folder: 'createOIDCProfile',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/createOIDCProfile'

                                                    },
                                                    {
                                                        name: 'deleteGroup',
                                                        folder: 'deleteGroup',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/deleteGroup'

                                                    },
                                                    {
                                                        name: 'deleteUser',
                                                        folder: 'deleteUser',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/deleteUser'

                                                    },
                                                    {
                                                        name: 'getGroups',
                                                        folder: 'getGroups',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/getGroups'

                                                    },
                                                    {
                                                        name: 'getUsers',
                                                        folder: 'getUsers',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/getUsers'

                                                    },
                                                    {
                                                        name: 'updateUser',
                                                        folder: 'updateUser',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/java/updateUser'

                                                    }

                                                ]
                                            },
                                            {
                                                name: 'oidclogin',
                                                folder: '/api-developer-guide/middleware/pub/security/oidclogin',
                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin',
                                                submenu: [
                                                    {
                                                        name: 'google',
                                                        folder: '/api-developer-guide/middleware/pub/security/oidclogin/google',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/google',
                                                        submenu:[
                                                            {
                                                                name: 'LoginHandler',
                                                                folder: 'LoginHandler',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/google/LoginHandler'

                                                            },
                                                            {
                                                                name: 'oidcProfile',
                                                                folder: '',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/google/oidcProfile'

                                                            }
                                                        ]

                                                    },
                                                    {
                                                        name: 'keycloak',
                                                        folder: '/api-developer-guide/middleware/pub/security/oidclogin/keycloak',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/keycloak',
                                                        submenu:[
                                                            {
                                                                name: 'LoginHandler',
                                                                folder: 'LoginHandler',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/keycloak/LoginHandler'

                                                            },
                                                            {
                                                                name: 'oidcProfile',
                                                                folder: 'oidcProfile',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/keycloak/oidcProfile'

                                                            }
                                                        ]

                                                    },
                                                    {
                                                        name: 'okta',
                                                        folder: '/api-developer-guide/middleware/pub/security/oidclogin/okta',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/okta',
                                                        submenu:[
                                                            {
                                                                name: 'LoginHandler',
                                                                folder: 'LoginHandler',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/okta/LoginHandler'
                                                            },
                                                            {
                                                                name: 'oidcProfile',
                                                                folder: 'oidcProfile',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/okta/oidcProfile'
                                                            }
                                                        ]

                                                    },
                                                    {
                                                        name: 'users',
                                                        folder: '/api-developer-guide/middleware/pub/security/oidclogin/users',
                                                        url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/users',
                                                        submenu:[
                                                            {
                                                                name: 'assignStaticGroups',
                                                                folder: 'assignStaticGroups',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/users/assignStaticGroups'

                                                            },
                                                            {
                                                                name: 'createUser',
                                                                folder: 'createUser',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/users/createUser'

                                                            },
                                                            {
                                                                name: 'deleteUser',
                                                                folder: 'deleteUser',
                                                                url: '/docs/api-developer-guide/middleware/pub/security/oidclogin/users/deleteUser'

                                                            }
                                                        ]
                                                    }

                                                ]
                                            }
                                        ]


                                    },
                                    {
                                        name: 'server',
                                        folder: '/api-developer-guide/middleware/pub/server',
                                        url: '/docs/api-developer-guide/middleware/pub/server',
                                        submenu: [
                                            {
                                                name: 'browse',
                                                folder: '/api-developer-guide/middleware/pub/server/browse',
                                                url: '/docs/api-developer-guide/middleware/pub/server/browse',
                                                submenu:[
                                                    {
                                                        name: 'apiLogs',
                                                        folder: 'apiLogs',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/apiLogs'
                                                    },
                                                    {
                                                        name: 'delete',
                                                        folder: 'delete',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/delete'
                                                    },
                                                    {
                                                        name: 'getFile',
                                                        folder: 'getFile',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/getFile'
                                                    },
                                                    {
                                                        name: 'getGUIsAsTree',
                                                        folder: 'getGUIsAsTree',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/getGUIsAsTree'
                                                    },
                                                    {
                                                        name: 'getPackageAsTree',
                                                        folder: 'getPackageAsTree',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/getPackageAsTree'
                                                    },
                                                    {
                                                        name: 'getURLAlias',
                                                        folder: 'getURLAlias',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/getURLAlias'
                                                    },
                                                    {
                                                        name: 'lock',
                                                        folder: '/api-developer-guide/middleware/pub/server/lock',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/lock'
                                                    },
                                                    {
                                                        name: 'logOut',
                                                        folder: 'logOut',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/logOut'
                                                    },
                                                    {
                                                        name: 'registerURLAlias',
                                                        folder: 'registerURLAlias',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/registerURLAlias'
                                                    },
                                                    {
                                                        name: 'saveAPI',
                                                        folder: 'saveAPI',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/saveAPI'
                                                    },
                                                    {
                                                        name: 'saveEmptyFolder',
                                                        folder: 'saveEmptyFolder',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/saveEmptyFolder'
                                                    },
                                                    {
                                                        name: 'saveFile',
                                                        folder: 'saveFile',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/saveFile'
                                                    },
                                                    {
                                                        name: 'saveFlow',
                                                        folder: 'saveFlow',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/saveFLow'
                                                    },
                                                    {
                                                        name: 'saveService',
                                                        folder: 'saveService',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/saveService'
                                                    },
                                                    {
                                                        name: 'saveSQL',
                                                        folder: 'saveSQL',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/saveSQL'
                                                    },
                                                    {
                                                        name: 'serverLogs',
                                                        folder: 'serverLogs',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/serverLogs'
                                                    },
                                                    {
                                                        name: 'serviceLog',
                                                        folder: 'serviceLog',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/serviceLog'
                                                    },
                                                    {
                                                        name: 'unLock',
                                                        folder: 'unLock',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/unLock'
                                                    },
                                                    {
                                                        name: 'uploadFile',
                                                        folder: 'uploadFile',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/browse/uploadFile'
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'build',
                                                folder: '/api-developer-guide/middleware/pub/server/build',
                                                url: '/docs/api-developer-guide/middleware/pub/server/build',
                                                submenu:[
                                                    {
                                                        name: 'checkBuildUpdate',
                                                        folder: 'checkBuildUpdate',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/checkBuildUpdate'
                                                    },
                                                    {
                                                        name: 'createBuild',
                                                        folder: 'createBuild',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/createBuild'
                                                    },
                                                    {
                                                        name: 'getUpdateStatus',
                                                        folder: 'getUpdateStatus',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/getUpdateStatus'
                                                    },
                                                    {
                                                        name: 'importBuild',
                                                        folder: 'importBuild',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/importBuild'
                                                    },
                                                    {
                                                        name: 'promoteBuild',
                                                        folder: 'promoteBuild',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/promoteBuild'
                                                    },
                                                    {
                                                        name: 'saveTest',
                                                        folder: 'saveTest',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/saveTest'
                                                    },
                                                    {
                                                        name: 'Sysinfo',
                                                        folder: 'Sysinfo',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/sysinfo'
                                                    },
                                                    {
                                                        name: 'updateBuild',
                                                        folder: 'updateBuild',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/updateBuild'
                                                    },
                                                    {
                                                        name: 'updateLicenseKey',
                                                        folder: 'updateLicenseKey',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/build/updateLicenseKey'
                                                    }

                                                ]
                                            },
                                            {
                                                name: 'core',
                                                folder: '/api-developer-guide/middleware/pub/server/core',
                                                url: '/docs/api-developer-guide/middleware/pub/server/core',
                                                submenu:[
                                                    {
                                                        name: 'getStartUpServices',
                                                        folder: 'getStartUpServices',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/core/getStartUpServices'
                                                    },
                                                    {
                                                        name: 'listCurrentRunningServices',
                                                        folder: 'listCurrentRunningServices',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/core/listCurrentRunningServices'
                                                    },
                                                    {
                                                        name: 'RebootServer',
                                                        folder: 'RebootServer',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/core/RebootServer'
                                                    },
                                                    {
                                                        name: 'service',
                                                        folder: 'service',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/core/service'
                                                    },
                                                    {
                                                        name: 'updateLicense',
                                                        folder: 'updateLicense',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/core/updateLicense'
                                                    },
                                                    {
                                                        name: 'updateLicenseService',
                                                        folder: 'updateLicenseService',
                                                        url: '/docs/api-developer-guide/middleware/pub/server/core/updateLicenseService'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: 'service',
                                        folder: '/api-developer-guide/middleware/pub/service',
                                        url: '/docs/api-developer-guide/middleware/pub/service',
                                        submenu: [
                                            {
                                                name: 'utils',
                                                folder: '/api-developer-guide/middleware/pub/service/utils',
                                                url: '/docs/api-developer-guide/middleware/pub/service/utils',
                                                submenu:[
                                                    {
                                                        name: 'await',
                                                        folder: 'await',
                                                        url: '/docs/api-developer-guide/middleware/pub/service/utils/await'
                                                    },
                                                    {
                                                        name: 'execute',
                                                        folder: 'execute',
                                                        url: '/docs/api-developer-guide/middleware/pub/service/utils/execute'
                                                    },
                                                    {
                                                        name: 'getLastErrorDump',
                                                        folder: 'getLastErrorDump',
                                                        url: '/docs/api-developer-guide/middleware/pub/service/utils/getLastErrorDump'
                                                    },
                                                    {
                                                        name: 'getMultipart',
                                                        folder: 'getMultipart',
                                                        url: '/docs/api-developer-guide/middleware/pub/service/utils/getMultipart'
                                                    },
                                                    {
                                                        name: 'getTenantInfo',
                                                        folder: 'getTenantInfo',
                                                        url: '/docs/api-developer-guide/middleware/pub/service/utils/getTenantInfo'
                                                    },
                                                    {
                                                        name: 'redirect',
                                                        folder: 'redirect',
                                                        url: '/docs/api-developer-guide/middleware/pub/service/utils/redirect'
                                                    },
                                                    {
                                                        name: 'returnFile',
                                                        folder: 'returnFile',
                                                        url: '/docs/api-developer-guide/middleware/pub/service/utils/returnFile'
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'auditLogging',
                                                folder: 'auditLogging',
                                                url: '/docs/api-developer-guide/middleware/pub/service/auditLogging'
                                            },
                                            {
                                                name: 'CleanServiceJSON',
                                                folder: 'CleanServiceJSON',
                                                url: '/docs/api-developer-guide/middleware/pub/service/CleanServiceJSON'
                                            },
                                            {
                                                name: 'continueRepeat',
                                                folder: 'continueRepeat',
                                                url: '/docs/api-developer-guide/middleware/pub/service/continueRepeat'
                                            },
                                            {
                                                name: 'debugLog',
                                                folder: 'debugLog',
                                                url: '/docs/api-developer-guide/middleware/pub/service/debugLog'
                                            },
                                            {
                                                name: 'DeleteSnap',
                                                folder: 'DeleteSnap',
                                                url: '/docs/api-developer-guide/middleware/pub/service/DeleteSnap'
                                            },
                                            {
                                                name: 'DeleteSnapshot',
                                                folder: 'DeleteSnapshot',
                                                url: '/docs/api-developer-guide/middleware/pub/service/DeleteSnapshot'
                                            },
                                            {
                                                name: 'DeleteTest',
                                                folder: 'DeleteTest',
                                                url: '/docs/api-developer-guide/middleware/pub/service/DeleteTest'
                                            },
                                            {
                                                name: 'DeleteTestCase',
                                                folder: 'DeleteTestCase',
                                                url: '/docs/api-developer-guide/middleware/pub/service/DeleteTestCase'
                                            },
                                            {
                                                name: 'doesServiceExists',
                                                folder: 'doesServiceExists',
                                                url: '/docs/api-developer-guide/middleware/pub/service/doesServiceExists'
                                            },
                                            {
                                                name: 'endpoints',
                                                folder: 'endpoints',
                                                url: '/docs/api-developer-guide/middleware/pub/service/endpoints'
                                            },
                                            {
                                                name: 'exitRepeat',
                                                folder: 'exitRepeat',
                                                url: '/docs/api-developer-guide/middleware/pub/service/exitRepeat'
                                            },
                                            {
                                                name: 'findAuditLoggingByFQN',
                                                folder: 'findAuditLoggingByFQN',
                                                url: '/docs/api-developer-guide/middleware/pub/service/findAuditLoggingByFQN'
                                            },
                                            {
                                                name: 'findAuditLoggingBySessionIDAndCorrelationID',
                                                folder: 'findAuditLoggingBySessionIDAndCorrelationID',
                                                url: '/docs/api-developer-guide/middleware/pub/service/findAuditLoggingBySessionIDAndCorrelationID'
                                            },
                                            {
                                                name: 'findReferences',
                                                folder: 'findReferences',
                                                url: '/docs/api-developer-guide/middleware/pub/service/findReferences'
                                            },
                                            {
                                                name: 'getAuditLoggingData',
                                                folder: 'getAuditLoggingData',
                                                url: '/docs/api-developer-guide/middleware/pub/service/getAuditLoggingData'
                                            },
                                            {
                                                name: 'getCurrentUserAccount',
                                                folder: 'getCurrentUserAccount',
                                                url: '/docs/api-developer-guide/middleware/pub/service/getCurrentUserAccount'
                                            },
                                            {
                                                name: 'getFQNByFolderScanning',
                                                folder: 'getFQNByFolderScanning',
                                                url: '/docs/api-developer-guide/middleware/pub/service/getFQNByFolderScanning'
                                            },
                                            {
                                                name: 'getLogs',
                                                folder: 'getLogs',
                                                url: '/docs/api-developer-guide/middleware/pub/service/getLogs'
                                            },
                                            {
                                                name: 'keyLogger',
                                                folder: 'keyLogger',
                                                url: '/docs/api-developer-guide/middleware/pub/service/keyLogger'
                                            },
                                            {
                                                name: 'loadCustomJar',
                                                folder: 'loadCustomJar',
                                                url: '/docs/api-developer-guide/middleware/pub/service/loadCustomJar'
                                            },
                                            {
                                                name: 'sleep',
                                                folder: 'sleep',
                                                url: '/docs/api-developer-guide/middleware/pub/service/sleep'
                                            },
                                            {
                                                name: 'snapShot',
                                                folder: 'snapShot',
                                                url: '/docs/api-developer-guide/middleware/pub/service/snapShot'
                                            },
                                            {
                                                name: 'throwException',
                                                folder: 'throwException',
                                                url: '/docs/api-developer-guide/middleware/pub/service/throwException'
                                            },
                                            {
                                                name: 'throwException',
                                                folder: 'throwException',
                                                url: '/docs/api-developer-guide/middleware/pub/service/throwException'
                                            },
                                            {
                                                name: 'wait',
                                                folder: 'wait',
                                                url: '/docs/api-developer-guide/middleware/pub/service/wait'
                                            },
                                            {
                                                name: 'waitFor',
                                                folder: 'waitFor',
                                                url: '/docs/api-developer-guide/middleware/pub/service/waitFor'
                                            }
                                        ]

                                    },
                                    {
                                        name: 'specs',
                                        folder: '/api-developer-guide/middleware/pub/specs',
                                        url: '/docs/api-developer-guide/middleware/pub/specs',
                                        submenu: [
                                            {
                                                name: 'postman',
                                                folder: '/api-developer-guide/middleware/pub/specs/postman',
                                                url: '/docs/api-developer-guide/middleware/pub/specs/postman',
                                                submenu: [
                                                    {
                                                        name: 'v3',
                                                        folder: '/api-developer-guide/middleware/pub/specs/postman/v3',
                                                        url: '/docs/api-developer-guide/middleware/pub/specs/postman/v3',
                                                        submenu:[
                                                            {
                                                                name: 'fileRenammer',
                                                                folder: 'fileRenammer',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/postman/v3/fileRenammer'
                                                            },
                                                            {
                                                                name: 'get_a_collection',
                                                                folder: 'get_a_collection',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/postman/v3/get_a_collection'
                                                            },
                                                            {
                                                                name: 'getAssetAndType',
                                                                folder: 'getAssetAndType',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/postman/v3/getAssetAndType'
                                                            },
                                                            {
                                                                name: 'import',
                                                                folder: 'import',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/postman/v3/import'
                                                            },
                                                            {
                                                                name: 'PostmanImport',
                                                                folder: 'PostmanImport',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/postman/v3/PostmanImport'
                                                            },
                                                            {
                                                                name: 'publishToMarketplace',
                                                                folder: 'publishToMarketplace',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/postman/v3/publishToMarketplace'
                                                            }
                                                        ]
                                                    }
                                                ]

                                            },
                                            {
                                                name: 'swagger',
                                                folder: '/api-developer-guide/middleware/pub/specs/swagger',
                                                url: '/docs/api-developer-guide/middleware/pub/specs/swagger',
                                                submenu: [
                                                    {
                                                        name: 'v3',
                                                        folder: '/api-developer-guide/middleware/pub/specs/swagger/v3',
                                                        url: '/docs/api-developer-guide/middleware/pub/specs/swagger/v3',
                                                        submenu:[
                                                            {
                                                                name: 'exportMultipleSwagger',
                                                                folder: 'exportMultipleSwagger',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/swagger/v3/exportMultipleSwagger'
                                                            },
                                                            {
                                                                name: 'exportSwagger',
                                                                folder: 'exportSwagger',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/swagger/v3/exportSwagger'
                                                            },
                                                            {
                                                                name: 'Generate',
                                                                folder: 'Generate',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/swagger/v3/Generate'
                                                            },
                                                            {
                                                                name: 'GenerateSwagger',
                                                                folder: 'GenerateSwagger',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/swagger/v3/GenerateSwagger'
                                                            },
                                                            {
                                                                name: 'import',
                                                                folder: 'import',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/swagger/v3/import'
                                                            },
                                                            {
                                                                name: 'swaggerImport',
                                                                folder: 'swaggerImport',
                                                                url: '/docs/api-developer-guide/middleware/pub/specs/swagger/v3/swaggerImport'
                                                            }
                                                        ]
                                                    }
                                                ]

                                            }

                                        ]
                                    },
                                    {
                                        name: 'sql',
                                        folder: '/api-developer-guide/middleware/pub/sql',
                                        url: '/docs/api-developer-guide/middleware/pub/sql',
                                        submenu:[
                                            {
                                                name: 'bulkInsertQuery',
                                                folder: 'bulkInsertQuery',
                                                url: '/docs/api-developer-guide/middleware/pub/sql/bulkInsertQuery'
                                            },
                                            {
                                                name: 'stringToQuery',
                                                folder: 'stringToQuery',
                                                url: '/docs/api-developer-guide/middleware/pub/sql/stringToQuery'
                                            }
                                        ]

                                    },
                                    {
                                        name: 'string',
                                        folder: '/api-developer-guide/middleware/pub/string',
                                        url: '/docs/api-developer-guide/middleware/pub/string',
                                        submenu:[
                                            {
                                                name: 'bytesToHexString',
                                                folder: 'bytesToHexString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/bytesToHexString'
                                            },
                                            {
                                                name: 'bytesToString',
                                                folder: 'bytesToString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/bytesToString'
                                            },
                                            {
                                                name: 'compare',
                                                folder: 'compare',
                                                url: '/docs/api-developer-guide/middleware/pub/string/compare'
                                            },
                                            {
                                                name: 'compareString',
                                                folder: 'compareString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/compareString'
                                            },
                                            {
                                                name: 'compareStrings',
                                                folder: 'compareStrings',
                                                url: '/docs/api-developer-guide/middleware/pub/string/compareStrings'
                                            },
                                            {
                                                name: 'concat',
                                                folder: 'concat',
                                                url: '/docs/api-developer-guide/middleware/pub/string/concat'
                                            },
                                            {
                                                name: 'decodeBase64',
                                                folder: 'decodeBase64',
                                                url: '/docs/api-developer-guide/middleware/pub/string/decodeBase64'
                                            },
                                            {
                                                name: 'decodeHTML',
                                                folder: 'decodeHTML',
                                                url: '/docs/api-developer-guide/middleware/pub/string/decodeHTML'
                                            },
                                            {
                                                name: 'encodeBase64',
                                                folder: 'encodeBase64',
                                                url: '/docs/api-developer-guide/middleware/pub/string/encodeBase64'
                                            },
                                            {
                                                name: 'encodeHTML',
                                                folder: 'encodeHTML',
                                                url: '/docs/api-developer-guide/middleware/pub/string/encodeHTML'
                                            },
                                            {
                                                name: 'equals',
                                                folder: 'equals',
                                                url: '/docs/api-developer-guide/middleware/pub/string/equals'
                                            },
                                            {
                                                name: 'equalsIgnoreCase',
                                                folder: 'equalsIgnoreCase',
                                                url: '/docs/api-developer-guide/middleware/pub/string/equalsIgnoreCase'
                                            },
                                            {
                                                name: 'escapeSQL',
                                                folder: 'escapeSQL',
                                                url: '/docs/api-developer-guide/middleware/pub/string/escapeSQL'
                                            },
                                            {
                                                name: 'fromXML',
                                                folder: 'fromXML',
                                                url: '/docs/api-developer-guide/middleware/pub/string/fromXML'
                                            },
                                            {
                                                name: 'htmlDecode',
                                                folder: 'htmlDecode',
                                                url: '/docs/api-developer-guide/middleware/pub/string/htmlDecode'
                                            },
                                            {
                                                name: 'htmlEncode',
                                                folder: 'htmlEncode',
                                                url: '/docs/api-developer-guide/middleware/pub/string/htmlEncode'
                                            },
                                            {
                                                name: 'indexOf',
                                                folder: 'indexOf',
                                                url: '/docs/api-developer-guide/middleware/pub/string/indexOf'
                                            },
                                            {
                                                name: 'isAlphanumeric',
                                                folder: 'isAlphanumeric',
                                                url: '/docs/api-developer-guide/middleware/pub/string/isAlphanumeric'
                                            },
                                            {
                                                name: 'isBlank',
                                                folder: 'isBlank',
                                                url: '/docs/api-developer-guide/middleware/pub/string/isBlank'
                                            },
                                            {
                                                name: 'isDate',
                                                folder: 'isDate',
                                                url: '/docs/api-developer-guide/middleware/pub/string/isDate'
                                            },
                                            {
                                                name: 'isEmpty',
                                                folder: 'isEmpty',
                                                url: '/docs/api-developer-guide/middleware/pub/string/isEmpty'
                                            },
                                            {
                                                name: 'isNumber',
                                                folder: 'isNumber',
                                                url: '/docs/api-developer-guide/middleware/pub/string/isNumber'
                                            },
                                            {
                                                name: 'length',
                                                folder: 'length',
                                                url: '/docs/api-developer-guide/middleware/pub/string/length'
                                            },
                                            {
                                                name: 'lookupDict',
                                                folder: 'lookupDict',
                                                url: '/docs/api-developer-guide/middleware/pub/string/lookupDict'
                                            },
                                            {
                                                name: 'maskString',
                                                folder: 'maskString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/maskString'
                                            },
                                            {
                                                name: 'messageDigest',
                                                folder: 'messageDigest',
                                                url: '/docs/api-developer-guide/middleware/pub/string/messageDigest'
                                            },
                                            {
                                                name: 'messageFormat',
                                                folder: 'messageFormat',
                                                url: '/docs/api-developer-guide/middleware/pub/string/messageFormat'
                                            },
                                            {
                                                name: 'NullOrWhiteSpc',
                                                folder: 'NullOrWhiteSpc',
                                                url: '/docs/api-developer-guide/middleware/pub/string/NullOrWhiteSpc'
                                            },
                                            {
                                                name: 'objectToString',
                                                folder: 'objectToString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/objectToString'
                                            },
                                            {
                                                name: 'padLeft',
                                                folder: 'padLeft',
                                                url: '/docs/api-developer-guide/middleware/pub/string/padLeft'
                                            },
                                            {
                                                name: 'replace',
                                                folder: 'replace',
                                                url: '/docs/api-developer-guide/middleware/pub/string/replace'
                                            },
                                            {
                                                name: 'rightPad',
                                                folder: 'rightPad',
                                                url: '/docs/api-developer-guide/middleware/pub/string/rightPad'
                                            },
                                            {
                                                name: 'stringConcat',
                                                folder: 'stringConcat',
                                                url: '/docs/api-developer-guide/middleware/pub/string/stringConcat'
                                            },
                                            {
                                                name: 'stringIndexOf',
                                                folder: 'stringIndexOf',
                                                url: '/docs/api-developer-guide/middleware/pub/string/stringIndexOf'
                                            },
                                            {
                                                name: 'stringToBytes',
                                                folder: 'stringToBytes',
                                                url: '/docs/api-developer-guide/middleware/pub/string/stringToBytes'
                                            },
                                            {
                                                name: 'subString',
                                                folder: 'subString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/subString'
                                            },
                                            {
                                                name: 'TextArrayToTextString',
                                                folder: 'TextArrayToTextString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/TextArrayToTextString'
                                            },
                                            {
                                                name: 'TextListCollector',
                                                folder: 'TextListCollector',
                                                url: '/docs/api-developer-guide/middleware/pub/string/TextListCollector'
                                            },
                                            {
                                                name: 'tokenize',
                                                folder: 'tokenize',
                                                url: '/docs/api-developer-guide/middleware/pub/string/tokenize'
                                            },
                                            {
                                                name: 'toLower',
                                                folder: 'toLower',
                                                url: '/docs/api-developer-guide/middleware/pub/string/toLower'
                                            },
                                            {
                                                name: 'toString',
                                                folder: 'toString',
                                                url: '/docs/api-developer-guide/middleware/pub/string/toString'
                                            },
                                            {
                                                name: 'toUpper',
                                                folder: 'toUpper',
                                                url: '/docs/api-developer-guide/middleware/pub/string/toUpper'
                                            },
                                            {
                                                name: 'trim',
                                                folder: 'trim',
                                                url: '/docs/api-developer-guide/middleware/pub/string/trim'
                                            },
                                            {
                                                name: 'urlDecode',
                                                folder: 'urlDecode',
                                                url: '/docs/api-developer-guide/middleware/pub/string/urlDecode'
                                            }
                                        ]

                                    },

                                    {
                                        name: 'syncloopGPT',
                                        folder: '/api-developer-guide/middleware/pub/syncloopGPT',
                                        url: '/docs/api-developer-guide/middleware/pub/syncloopGPT',
                                        submenu:[
                                            {
                                                name: 'add_message',
                                                folder: 'add_message',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/add_message'
                                            },
                                            {
                                                name: 'checkIfTokenExists',
                                                folder: 'checkIfTokenExists',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/checkIfTokenExists'
                                            },
                                            {
                                                name: 'create_assistant',
                                                folder: 'create_assistant',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/create_assistant'
                                            },
                                            {
                                                name: 'create_run',
                                                folder: 'create_run',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/create_run'
                                            },
                                            {
                                                name: 'create_thread',
                                                folder: 'create_thread',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/create_thread'
                                            },
                                            {
                                                name: 'fetchResultByPolling',
                                                folder: 'fetchResultByPolling',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/fetchResultByPolling'
                                            },
                                            {
                                                name: 'get_results_through_assistant',
                                                folder: 'get_results_through_assistant',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/get_results_through_assistant'
                                            },
                                            {
                                                name: 'getMyAssistantId',
                                                folder: 'getMyAssistantId',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/getMyAssistantId'
                                            },
                                            {
                                                name: 'list_messages',
                                                folder: 'list_messages',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/list_messages'
                                            },
                                            {
                                                name: 'run_stream',
                                                folder: 'run_stream',
                                                url: '/docs/api-developer-guide/middleware/pub/syncloopGPT/run_stream'
                                            }
                                        ]
                                    },
                                    {
                                        name: 'tenant',
                                        folder: '/api-developer-guide/middleware/pub/tenant',
                                        url: '/docs/api-developer-guide/middleware/pub/tenant',
                                        submenu:[
                                            {
                                                name: 'createNew',
                                                folder: 'createNew',
                                                url: '/docs/api-developer-guide/middleware/pub/tenant/createNew'
                                            }
                                        ]

                                    },
                                    {
                                        name: 'util',
                                        folder: '/api-developer-guide/middleware/pub/util',
                                        url: '/docs/api-developer-guide/middleware/pub/util',
                                        submenu:[
                                            {
                                                name: 'format',
                                                folder: '/api-developer-guide/middleware/pub/util/format',
                                                url: '/docs/api-developer-guide/middleware/pub/util/format/format',
                                                submenu:[
                                                    {
                                                        name: 'formatCurrency',
                                                        folder: 'formatCurrency',
                                                        url: '/docs/api-developer-guide/middleware/pub/util/format/formatCurrency'

                                                    },
                                                    {
                                                        name: 'formatPercentage',
                                                        folder: 'formatPercentage',
                                                        url: '/docs/api-developer-guide/middleware/pub/util/format/formatPercentage'

                                                    }
                                                ]

                                            },
                                            {
                                                name: 'ContextObjectExec',
                                                folder: 'contentObjectExec',
                                                url: '/docs/api-developer-guide/middleware/pub/util/ContextObjectExec'
                                            },
                                            {
                                                name: 'getSavedTests',
                                                folder: 'getSavedTests',
                                                url: '/docs/api-developer-guide/middleware/pub/util/getSavedTests'
                                            },
                                            {
                                                name: 'getUrlMappingFileProperties',
                                                folder: 'getUrlMappingFileProperties',
                                                url: '/docs/api-developer-guide/middleware/pub/util/getUrlMappingFileProperties'
                                            },
                                            {
                                                name: 'JavaFunctionExec',
                                                folder: 'javaFunctionExec',
                                                url: '/docs/api-developer-guide/middleware/pub/util/JavaFunctionExec'
                                            },
                                            {
                                                name: 'NotifyAdmin',
                                                folder: 'notifyAdmin',
                                                url: '/docs/api-developer-guide/middleware/pub/util/NotifyAdmin'
                                            },

                                            {
                                                name: 'saveServerProperties',
                                                folder: 'saveServerProperties',
                                                url: '/docs/api-developer-guide/middleware/pub/util/saveServerProperties'
                                            },
                                            {
                                                name: 'saveServerPropertiesAPI',
                                                folder: 'saveServerPropertiesAPI',
                                                url: '/docs/api-developer-guide/middleware/pub/util/saveServerPropertiesAPI'
                                            },
                                            {
                                                name: 'saveURLMappingProperties',
                                                folder: 'saveURLMappingProperties',
                                                url: '/docs/api-developer-guide/middleware/pub/util/saveURLMappingProperties'
                                            },
                                            {
                                                name: 'saveURLMappingPropertiesApi',
                                                folder: 'saveURLMappingPropertiesApi',
                                                url: '/docs/api-developer-guide/middleware/pub/util/saveURLMappingPropertiesApi'
                                            },
                                            {
                                                name: 'serverProperties',
                                                folder: 'serverProperties',
                                                url: '/docs/api-developer-guide/middleware/pub/util/serverProperties'
                                            },
                                            {
                                                name: 'SyncloopIOToSchema',
                                                folder: 'SyncloopIOToSchema',
                                                url: '/docs/api-developer-guide/middleware/pub/util/SyncloopIOToSchema'
                                            },

                                        ]

                                    },
                                    {
                                        name: 'xml',
                                        folder: '/api-developer-guide/middleware/pub/xml',
                                        url: '/docs/api-developer-guide/middleware/pub/xml',
                                        submenu:[
                                            {
                                                name: 'addAttribute',
                                                folder: 'addAttribute',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/addAttribute'

                                            },
                                            {
                                                name: 'addChildNode',
                                                folder: 'addChildNode',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/addChildNode'

                                            },
                                            {
                                                name: 'createDocument',
                                                folder: 'createDocument',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/createDocument'

                                            },
                                            {
                                                name: 'createNode',
                                                folder: 'createNode',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/createNode'

                                            },
                                            {
                                                name: 'createTextNode',
                                                folder: 'createTextNode',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/createTextNode'

                                            },
                                            {
                                                name: 'fromXML',
                                                folder: 'fromXML',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/fromXML'

                                            },
                                            {
                                                name: 'fromXMLSpecification',
                                                folder: 'fromXMLSpecification',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/fromXMLSpecification'

                                            },
                                            {
                                                name: 'serialize',
                                                folder: 'serialize',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/serialize'

                                            },
                                            {
                                                name: 'toXML',
                                                folder: 'toXML',
                                                url: '/docs/api-developer-guide/middleware/pub/xml/toXML'

                                            }


                                        ]

                                    }
                                ]

                            }

                        ]
                    }
                ]

            },
            {
                name: 'User Guide',
                folder: '/user-guide',
                url: '/docs/user-guide',
                submenu:[
                    {
                        name: 'Dashboard',
                        folder: 'dashboard',
                        url: '/docs/user-guide/dashboard',
                        submenu:[
                            {
                                name: 'Getting Started',
                                folder: 'dashboardPage',
                                url: '/docs/user-guide/dashboard/dashboard'
                            },
                            {
                                name: 'Workspace',
                                folder: 'workspace',
                                url: '/docs/user-guide/dashboard/workspace',
                                submenu:[
                                    {

                                        name: 'Packages',
                                        folder: 'packages',
                                        url: '/docs/user-guide/dashboard/workspace/packages'

                                    },
                                    {
                                        name: 'Services',
                                        folder: 'services',
                                        url: '/docs/user-guide/dashboard/workspace/services',
                                        submenu:[
                                            {
                                                name: 'API',
                                                folder: 'api',
                                                url: '/docs/user-guide/dashboard/workspace/services/api',
                                                submenu:[
                                                    {
                                                        name: 'Getting Started',
                                                        folder: 'api_page',
                                                        url: '/docs/user-guide/dashboard/workspace/services/api/api_page'
                                                    },
                                                    {
                                                        name: 'API Parameters',
                                                        folder: 'api-parameters',
                                                        url: '/docs/user-guide/dashboard/workspace/services/api/api-parameters'

                                                    },
                                                    {
                                                        name: 'Configure Properties',
                                                        folder: 'configure_properties',
                                                        url: '/docs/user-guide/dashboard/workspace/services/api/configure_properties'

                                                    },
                                                    {
                                                        name: 'Control Structures',
                                                        folder: 'control-structures',
                                                        url: '/docs/user-guide/dashboard/workspace/services/api/control-structures',
                                                        submenu:[
                                                            {
                                                                name: 'Transformer',
                                                                folder: 'transformer',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/transformer'
                                                            },
                                                            {
                                                                name: 'Group',
                                                                folder: 'group',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/group'
                                                            },
                                                            {
                                                                name: 'If-Else',
                                                                folder: 'ifelse',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/ifelse'
                                                            },
                                                            {
                                                                name: 'Switch',
                                                                folder: 'switch',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/switch'
                                                            },
                                                            {
                                                                name: 'ForEach',
                                                                folder: 'foreach',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/foreach'
                                                            },
                                                            {
                                                                name: 'TCF Block',
                                                                folder: 'tcf-block',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/tcf-block'
                                                            },
                                                            {
                                                                name: 'Redo',
                                                                folder: 'redo',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/redo'
                                                            },
                                                            {
                                                                name: 'Await',
                                                                folder: 'await',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/await'
                                                            },
                                                            {
                                                                name: 'Service',
                                                                folder: 'service',
                                                                url: '/docs/user-guide/dashboard/workspace/services/api/control-structures/service'
                                                            }

                                                        ]
                                                    },
                                                    {
                                                        name: 'API Dashboard',
                                                        folder: 'api-dashboard',
                                                        url: '/docs/user-guide/dashboard/workspace/services/api/api_dashboard'
                                                    },
                                                    {
                                                        name: 'Debugging',
                                                        folder: 'debugging',
                                                        url: '/docs/user-guide/dashboard/workspace/services/api/debugging'

                                                    },
                                                    {
                                                        name: 'Consumer Developer',
                                                        folder: 'consumer_developer',
                                                        url: '/docs/user-guide/dashboard/workspace/services/api/consumer_developer'

                                                    },

                                                ]
                                            },
                                            {
                                                name: 'Java',
                                                folder: 'Java',
                                                url: '/docs/user-guide/dashboard/workspace/services/java/java'
                                            },
                                            {
                                                name: 'SQL',
                                                folder: 'SQL',
                                                url: '/docs/user-guide/dashboard/workspace/services/sql/sql',
                                            }
                                        ]

                                    },
                                    {
                                        name: 'Variables and Datatypes',
                                        folder: 'variables-and-datatypes',
                                        url: '/docs/user-guide/dashboard/workspace/variables-and-datatypes'

                                    },
                                    {
                                        name: 'Configuration Types',
                                        folder: 'configuration_types',
                                        url: '/docs/user-guide/dashboard/workspace/configuration_types'

                                    },
                                    {
                                        name: 'Consumer/Developer Groups',
                                        folder: 'consumer_developer',
                                        url: '/docs/user-guide/dashboard/workspace/consumer_developer'

                                    },
                                    {
                                        name: 'Securing Variables',
                                        folder: 'securing-variables',
                                        url: '/docs/user-guide/dashboard/workspace/securing_variables'

                                    }



                                ]
                            },
                            {
                                name: 'Scheduler',
                                folder: 'scheduler',
                                url: '/docs/user-guide/dashboard/scheduler'

                            },
                            {
                                name: 'Export/Promote',
                                folder: 'export_promote',
                                url: '/docs/user-guide/dashboard/export_promote'

                            },
                            {
                                name: 'Import',
                                folder: 'import',
                                url: '/docs/user-guide/dashboard/import'

                            },
                            {
                                name: 'Server Logs',
                                folder: 'server_logs',
                                url: '/docs/user-guide/dashboard/server_logs'

                            },
                            {
                                name: 'API Token',
                                folder: 'api_token',
                                url: '/docs/user-guide/dashboard/api_token'

                            },
                            {
                                name: 'Settings',
                                folder: 'settings',
                                url: '/docs/user-guide/dashboard/settings',
                                submenu:[
                                    {
                                        name: 'Setting up',
                                        folder: 'setting_up',
                                        url: '/docs/user-guide/dashboard/settings/setting_up'
                                    },
                                    {
                                        name: 'Profile',
                                        folder: 'profile',
                                        url: '/docs/user-guide/dashboard/settings/profile'
                                    },
                                    {
                                        name: 'Team',
                                        folder: 'team',
                                        url: '/docs/user-guide/dashboard/settings/team'
                                    },
                                    {
                                        name: 'Group',
                                        folder: 'group',
                                        url: '/docs/user-guide/dashboard/settings/group'
                                    },
                                    {
                                        name: 'Environment',
                                        folder: 'environment',
                                        url: '/docs/user-guide/dashboard/settings/environment'
                                    },
                                    {
                                        name: 'Credentials',
                                        folder: 'credentials',
                                        url: '/docs/user-guide/dashboard/settings/credentials'
                                    },
                                    {
                                        name: 'System Information',
                                        folder: 'system_information',
                                        url: '/docs/user-guide/dashboard/settings/system_information'
                                    },
                                    {
                                        name: 'License',
                                        folder: 'licensing',
                                        url: '/docs/user-guide/dashboard/settings/licensing'
                                    }

                                ]

                            },
                            {
                                name: 'Import OpenAPI/Postman Collection',
                                folder: 'importAPIPostmanCollection',
                                url: '/docs/user-guide/dashboard/importAPIPostmanCollection'
                            },
                            {
                                name: 'Documentation',
                                folder: 'documentation',
                                url: '/docs/user-guide/dashboard/documentation'
                            },
                            {
                                name: 'Marketplace',
                                folder: 'marketplace',
                                url: '/docs/user-guide/dashboard/marketplace'
                            },
                            {
                                name: 'Monitor Services',
                                folder: 'monitor_services',
                                url: '/docs/user-guide/dashboard/monitor_services'
                            }



                        ]
                    }
                ]

            },
            {
                name: 'Syncloop Embedded Integration',
                folder: 'syncloop-embedded-integration',
                url: '/docs/syncloop-embedded-integration',
                submenu: [
                    {
                            name: 'Embedded API',
                            folder: 'embedded_api',
                            url: '/docs/syncloop-embedded-integration/api',
                            submenu:[
                               {
                                    name: 'Embedded API Dashboard',
                                    folder: 'embedded_api_dashboard',
                                    url: '/docs/syncloop-embedded-integration/api/api_embedded_dashboard'
                                },
                                {
                                    name: 'Embedded API Parameters',
                                    folder: 'embedded_api_parameters',
                                    url: '/docs/user-guide/syncloop-embedded-integration/api/api_embedded_parameters'
                                },
                                {
                                    name: 'Embedded API Debugging',
                                    folder: 'embedded_api_debugging',
                                    url: '/docs/user-guide/syncloop-embedded-integration/api/api_embedded_debugging'
                                }
                        ]
                    },
                    {
                        name: 'Introduction',
                        folder: 'introduction',
                        url: '/docs/syncloop-embedded-integration/introduction'
                    },
                    {
                        name: 'UI Editor Integration & JS API',
                        folder: 'ui-editor-integration',
                        url: '/docs/syncloop-embedded-integration/ui-editor-integration'
                    },
                    {
                        name: 'Integration Module',
                        folder: 'integration-module',
                        url: '/docs/syncloop-embedded-integration/integration-module'
                    },
                    {
                        name: 'Server Runtime',
                        folder: 'server-runtime',
                        url: '/docs/syncloop-embedded-integration/server-runtime'
                    },
                    {
                        name: 'Integration & Embedded Services',
                        folder: 'integration-embedded-services',
                        url: '/docs/syncloop-embedded-integration/integration-embedded-services'
                    },
                    {
                        name: 'Local Java Function Integration',
                        folder: 'local-java-function-integration',
                        url: '/docs/syncloop-embedded-integration/local-java-function-integration'
                    },
                    {
                        name: 'Enable Test & Trace',
                        folder: 'enable-test-trace',
                        url: '/docs/syncloop-embedded-integration/enable-test-trace'
                    }

                ]

            },
            {
                name: 'Syncloop GPT',
                folder: 'syncloop GPT',
                url: '/docs/syncloopgpt',
                submenu: [
                    {
                        name: 'Syncloop AI Training Data',
                        folder: 'syncloop_assistant',
                        url: '/docs/syncloopgpt/syncloop_assistant'
                    },
                    {
                        name: 'Setup Syncloop (chatGPT)',
                        folder: 'setup_gpt_token',
                        url: '/docs/syncloopgpt/setup_gpt_token'
                    }
                ]

            },
            {
                name: 'Syncloop AI',
                folder: 'syncloop-ai',
                url: '/docs/syncloop-ai',
                submenu: [
                            {
                                name: 'Getting Started',
                                folder: 'introduction-to-syncloop-ai',
                                url: '/docs/syncloop-ai/introduction-to-syncloop-ai'
                            },
                            {
                                name: 'Workspace',
                                folder: 'syncloop-ai-workspace',
                                url: '/docs/syncloop-ai/syncloop-ai-workspace'
                            },
                            {
                                name: 'Build & Design',
                                folder: 'build-and-design',
                                url: '/docs/syncloop-ai/build-and-design',
                                submenu: [
                                            {
                                                name: 'App',
                                                folder: 'app',
                                                url: '/docs/syncloop-ai/build-and-design/app'
                                            },
                                            {
                                                name: 'Team',
                                                folder: 'team',
                                                url: '/docs/syncloop-ai/build-and-design/teams'
                                            },
                                            {
                                                name: 'Agents',
                                                folder: 'agents',
                                                url: '/docs/syncloop-ai/build-and-design/agents'
                                            },
                                            {
                                                name: 'Tools',
                                                folder: 'tools',
                                                url: '/docs/syncloop-ai/build-and-design/tools'
                                            },
                                            {
                                                name: 'API',
                                                folder: 'api',
                                                url: '/docs/syncloop-ai/build-and-design/api'
                                            },
                                            {
                                                name: 'Import',
                                                folder: 'import',
                                                url: '/docs/syncloop-ai/build-and-design/import'
                                            },
                                            {
                                                name: 'Export',
                                                folder: 'export',
                                                url: '/docs/syncloop-ai/build-and-design/export'
                                            },
                                            {
                                                name: 'LLMs',
                                                folder: 'llm',
                                                url: '/docs/syncloop-ai/build-and-design/llm'
                                            },
                                            {
                                                name: 'Knowledge Base',
                                                folder: 'knowledge_base',
                                                url: '/docs/syncloop-ai/build-and-design/knowledgebase'
                                            },
                                            {
                                                name: 'RAG',
                                                folder: 'rag',
                                                url: '/docs/syncloop-ai/build-and-design/rag'
                                            },
                                            {
                                                name: 'Workspace',
                                                folder: 'workspace',
                                                url: '/docs/syncloop-ai/build-and-design/workspace'
                                            },
                                            {
                                                name: 'Logout',
                                                folder: 'logout',
                                                url: '/docs/syncloop-ai/build-and-design/logout'
                                            }

                                ]
                            },
                        ]
            },
            {
                name: 'Syncloop AI Swagger',
                folder: '/docs',
                url: '/docs/syncloop-ai-swagger'


            },
            {
                name: 'Run on docker',
                folder: '/docs',
                url: '/docs/deploy-docker'

            },
            {
                name: 'FAQs',
                folder: 'faq',
                url: '/docs/faq',
                submenu:[
                    {
                        name: 'Basic API Information',
                        folder: 'basic-api-introduction',
                        url: '/docs/faq/basic-api-introduction',
                    },
                    {
                        name: 'Community',
                        folder: 'community',
                        url: '/docs/faq/community',
                    },
                    {
                        name: 'Documentation',
                        folder: 'documentation',
                        url: '/docs/faq/documentation',
                    },
                    {
                        name: 'Environment',
                        folder: 'environment',
                        url: '/docs/faq/environment',
                    },
                    {
                        name: 'Pricing',
                        folder: 'pricing',
                        url: '/docs/faq/pricing',
                    },
                    {
                        name: 'Setup and Installation',
                        folder: 'setup-and-installation',
                        url: '/docs/faq/setup-and-installation',
                    },
                    {
                        name: 'Student Corner',
                        folder: 'student-corner',
                        url: '/docs/faq/student-corner',
                    }

                ]

            },
            {
                name: 'Java Docs',
                folder: 'java-docs',
                url: '/docs/java-docs'

            },
            {
                name: 'Blogs',
                folder: 'blogs',
                url: 'https://www.syncloop.com/blog.html'

            }
        ];
    }

    getList() {
       const sideBarNavList = [];
       return this._prepareList(this.sidebarNavItems, sideBarNavList);
    }

    _prepareList(list, sideBarNavList) {
        for (let i = 0 ; i < list.length ; i++ ) {
            sideBarNavList[list[i].url] = list[i].name;
            if (null != list[i].submenu) {
                sideBarNavList.concat(this._prepareList(list[i].submenu, sideBarNavList));
            }
        }
        return sideBarNavList;
    }

    render() {

        return (
            <div id="doc-accordian">
                <div className="form-group has-search d-none">
                    <span className="fa fa-search form-control-feedback"></span>
                    <input type="text" className="form-control" placeholder="Search"/>
                </div>
                <div className="dmt-button">
                    <i className="fa-light fa-circle-xmark"></i>
                </div>
                <ul className="show-dropdown">

                    {this.sidebarNavItems.map((item, index) => (
                        <ListMenu item={item}/>
                    ))}

                </ul>

            </div>
        );
    }
}
